import React from 'react';
import { Text, View } from 'react-native';
import DataDiaryTabView, {
  DataDiaryProps
} from '../../results/DataDiaryTabView';
import {
  ScreenComponentPlugin,
  ScreenComponentProps
} from '../ScreenComponentPlugin';

const DataDiaryCard: React.FC<ScreenComponentProps<DataDiaryProps>> = ({
  startDate,
  diaryRecord
}) => {
  return (
    <View>
      <DataDiaryTabView startDate={startDate} diaryRecord={diaryRecord} />
    </View>
  );
};

export const DataDiaryCardPlugin: ScreenComponentPlugin<DataDiaryProps> = {
  type: 'DataDiaryCard',
  name: 'Data Diary Card',
  categories: ['study-progress'],
  component: DataDiaryCard
};
